import React, { Component } from "react";
import UI from "../../shared/Components/UI/js";
import MainLayout from "../_components/MainLayout";
import { DeleteAccount } from "../../ComponentsFC/onboard/settings/delete/index";

const context = "onboard";
export default class OnboardAttendancePage extends Component {
  constructor() {
    super();
    this.state = {};
    UI.initiateView(this, {
      //Initial State Here
      active_tab: "Settings",
      context: context,
    });
  }

  render() {
    const _this = this;

    return (
      <MainLayout context={context} additional={"delete-account"} _this={_this}>
        <DeleteAccount />
      </MainLayout>
    );
  }
}
